import React, { useState } from 'react';

interface SettingsBlockProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
  /** Optional right-side element in header (badge, button) */
  headerRight?: React.ReactNode;
}

const SettingsBlock: React.FC<SettingsBlockProps> = ({
  title, defaultOpen = true, children, headerRight,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div style={{
      border: '1px solid rgba(0,0,0,.08)',
      borderRadius: 'var(--radius-card, 10px)',
      overflow: 'hidden',
      marginBottom: 'var(--space-l2, 12px)',
      boxShadow: '0 1px 3px rgba(0,0,0,.04)',
    }}>
      {/* Header */}
      <div
        onClick={() => setOpen(v => !v)}
        style={{
          padding: '9px 14px',
          background: 'rgba(0,0,0,.025)',
          borderBottom: open ? '1px solid rgba(0,0,0,.06)' : 'none',
          display: 'flex', alignItems: 'center', gap: 8,
          cursor: 'pointer', userSelect: 'none',
          transition: 'background .15s',
        }}
        onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = 'rgba(0,0,0,.04)'; }}
        onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = 'rgba(0,0,0,.025)'; }}
      >
        <span style={{
          fontSize: 10, fontWeight: 800, textTransform: 'uppercase',
          letterSpacing: '.08em', color: 'var(--text-color-calendar-week)',
          flex: 1,
        }}>
          {title}
        </span>
        {headerRight}
        <span style={{
          fontSize: 10, color: 'var(--text-color-calendar-week)',
          transform: open ? 'rotate(0deg)' : 'rotate(-90deg)',
          transition: 'transform .2s',
          display: 'inline-block',
          lineHeight: 1,
        }}>▾</span>
      </div>

      {/* Content — animated collapse */}
      <div style={{
        display: open ? 'block' : 'none',
      }}>
        {children}
      </div>
    </div>
  );
};

export default SettingsBlock;
